/**
 * Presets for the consultant course-search filter chips. Fee brackets are in
 * whole AUD dollars (the API converts to the `*_cents` columns). Intake months
 * are 1–12, matching master_courses.intake_months / tenant_private_courses.
 */

export type FeeBracket = {
  readonly key: string;
  readonly label: string;
  /** Inclusive lower bound in whole AUD dollars. */
  readonly min: number;
  /** Exclusive upper bound in whole AUD dollars, or null for open-ended. */
  readonly max: number | null;
};

export const FEE_BRACKETS: readonly FeeBracket[] = [
  { key: 'lt20k', label: 'Under $20k', min: 0, max: 20_000 },
  { key: '20to30k', label: '$20k–$30k', min: 20_000, max: 30_000 },
  { key: '30to40k', label: '$30k–$40k', min: 30_000, max: 40_000 },
  { key: 'gte40k', label: '$40k+', min: 40_000, max: null },
] as const;

/** Preset "max IELTS overall" thresholds for the English-band filter (≤ value). */
export const IELTS_MAX_OPTIONS = [5.5, 6.0, 6.5, 7.0] as const;

export const INTAKE_MONTHS: readonly { readonly value: number; readonly label: string }[] = [
  { value: 1, label: 'Jan' },
  { value: 2, label: 'Feb' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'Apr' },
  { value: 5, label: 'May' },
  { value: 6, label: 'Jun' },
  { value: 7, label: 'Jul' },
  { value: 8, label: 'Aug' },
  { value: 9, label: 'Sep' },
  { value: 10, label: 'Oct' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dec' },
] as const;
